module.exports = __webpack_public_path__ + "img/aire_acondicionado.9dda0bfb.svg";